import { jsPDF } from "jspdf";
import "jspdf-autotable";
import Axios from "axios";
import checkJwt from "./../../../Global/jwtChecker";

export default async function pdf(data, startDate, endDate, currency) {
    const unHashedJwt = await checkJwt();

    let info = await Axios("client/info", {
        method: "get",
        headers: { Authorization: unHashedJwt.data },
    }).then((res) => res.data);

    const doc = new jsPDF();

    //var myFont = base64.encode(Roboto) // load the *.ttf font file as binary string

    // add the font to jsPDF
    //.addFileToVFS("fonts/Roboto/Roboto-Black.ttf", myFont);
    doc.addFont("fonts/Roboto/Roboto-Regular.ttf", "Roboto", "normal");
    doc.setFont("Roboto", "normal");

    doc.setFontSize(40);
    //var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
    var pageWidth =
        doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
    doc.text(info.clientName, pageWidth / 2, 20, "center");

    doc.setFontSize(10);
    doc.text(info.clientFullAddress, pageWidth / 2, 30, "center");

    doc.text("TID ueđaja: " + data.deviceTid, 15, 40);
    doc.text("ISU ueđaja: " + data.deviceIsuNumber, 15, 45);
    doc.text("Datum od: " + startDate.toLocaleDateString("hr"), 15, 50);
    doc.text("Datum do: " + endDate.toLocaleDateString("hr"), 15, 55);

    doc.autoTable({
        head: [
            [
                "Poslovni prostor",
                "Karticni iznos",
                "Novcani iznos",
                "Ostali iznos",
                "Ukupno",
            ],
        ],
        body: [
            [
                data.businessPremisesLabel,
                Intl.NumberFormat("hr", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                }).format(data.cardAmount) + currency,
                Intl.NumberFormat("hr", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                }).format(data.cashAmount) + currency,
                Intl.NumberFormat("hr", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                }).format(data.theRestAmount) + currency,
                Intl.NumberFormat("hr", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                }).format(data.totalAmount) + currency,
            ],
        ],
        startY: 60,
        headStyles: { halign: "center" },
        theme: "grid",
        columnStyles: {
            1: { halign: "right" },
            2: { halign: "right" },
            3: { halign: "right" },
            4: { halign: "right" },
        },
        //theme: 'plain'
    });

    doc.autoTable({
        headStyles: { halign: "center" },
        theme: "grid",
        head: [["Porez", "Osnovica", "Iznos"]],
        body: data.taxes.map((info, index) => {
            return [
                info.taxRate + "%",
                Intl.NumberFormat("hr", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                }).format(info.taxBase) + currency,
                Intl.NumberFormat("hr", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                }).format(info.taxAmount) + currency,
            ];
        }),
        columnStyles: {
            1: { halign: "right" },
            2: { halign: "right" },
        },
    });

    doc.save("Izvjestaj.pdf");
}
